import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./style.scss";
import logo from "./images/logo.png";
import LoginForm from "./views/LoginForm";
import ForgotForm from "./views/ForgotForm";
import { useAppContext } from "../../AppContext";

function Login() {
  const [title] = useState("Login | Chimera Solutions | Integration Portal");
  const { chimeraserv, components } = useAppContext();
  const props = { chimeraserv, components };

  const routes = [
    {
      name: "Login",
      path: "",
      element: <LoginForm chimeraserv={props.chimeraserv} />,
    },
    // {
    //   name: "Forgot Password",
    //   path: "forgot",
    //   element: <ForgotForm chimeraserv={props.chimeraserv} />,
    // },
  ];

  return (
    <div className={"background"}>
      <div className={["container-fluid", "login"].join(" ")}>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <div className={"row"}>
          <div className={["rightCol"]}>
            <div className={["view"].join(" ")}>
              <img
                className={["logo"]}
                src={logo}
                alt={"Chimera Insights Logo"}
              />
              <div className={"portal-title"}>Integration Portal</div>
              <Routes>
                {routes.map((route, key) => (
                  <Route key={key} path={route.path} element={route.element} />
                ))}
                <Route
                  path="*"
                  element={
                    props.components.setting[0].component
                      ? React.createElement(
                          props.components.setting[0].component
                        )
                      : null
                  }
                />
              </Routes>
              <div className={["formFooter"]}>
                {/* <p>Do you want to register?</p>
              <p>Visit our website to learn more</p> */}
                <a
                  href={"https://www.chimerasol.com/"}
                  rel="noopener noreferrer"
                  target={"_blank"}
                >
                  www.chimerasol.com
                </a>
              </div>
            </div>
          </div>
          {/* <div
          className={["d-none", "d-md-block", "col-md-7", "leftCol"].join(" ")}
        /> */}
        </div>
      </div>
    </div>
  );
}

export default Login;
